import { useState, useEffect } from "react";

export default function useLocation(t) {
  const [userLocation, setUserLocation] = useState(null);
  const [locationError, setLocationError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!navigator.geolocation) {
      setLocationError(t?.locationNotSupported || "Geolocation is not supported in this browser.");
      setLoading(false);
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (pos) => {
        setUserLocation({
          lat: pos.coords.latitude,
          lng: pos.coords.longitude,
        });
        setLoading(false);
      },
      (err) => {
        console.error("Error getting location:", err);
        setLocationError(t?.locationDenied || "Location access denied.");
        setLoading(false);
      }
    );
  }, [t]);

  return { userLocation, locationError, loading };
}